import { render, staticRenderFns } from "./LocationDocumentModal.vue?vue&type=template&id=0c64cfa3&"
import script from "./LocationDocumentModal.vue?vue&type=script&lang=js&"
export * from "./LocationDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports